export default "__VITE_ASSET__ByhMRuN___"